import {ResidentTable} from "@/components/panel/residents-table";


export default function Residents() {
    return (
        <main className="container mx-auto p-4">
            <div className="space-y-8">
                <ResidentTable/>
            </div>
        </main>
    );
}
